module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/visa-e200b62045e49ef8c0662ae284e00ab8.svg";